import agentsReducer, { agentsActions } from './agents.slice';

export { agentsActions };

export default agentsReducer;
